module.exports = __webpack_public_path__ + "img/qr-app.7ef99684.svg";